var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c(
        "tinymce",
        {
          attrs: {
            init: _vm.configuration.init,
            id: _vm.tinyId,
            name: this.field.fieldName,
            required: this.field.required,
          },
          on: {
            keyup: function ($event) {
              return _vm.updateField()
            },
          },
          model: {
            value: _vm.input,
            callback: function ($$v) {
              _vm.input = $$v
            },
            expression: "input",
          },
        },
        [_vm._v("\n        " + _vm._s(this.field.value) + "\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }